<div style="margin: 10px;">
  <form [formGroup]="SettingsForm">
    <div class="mb-3 row">
      <div class="col-lg-3">
        <fieldset>
          <legend>Ping Settings</legend>
          <div style="margin-top: 10px;">
            <input type="checkbox" [formControl]="PingFirst" />
            <span class="uv-checkbox-label">Ping IPs/Devices First</span>
          </div>
          <br />
          <div>
            <label>Ping Timeout (milliseconds)</label>
            <input type="number" class="form-control" [formControl]="PingTimeout" />
            @if (PingTimeout.hasError('required')) {
              <div class="alert alert-danger">Ping Timeout is required</div>
            }
            @if (PingTimeout.hasError('minValue') || PingTimeout.hasError('maxValue')) {
              <div class="alert alert-danger">Ping Timeout must be in the range 250 - 25000</div>
            }
          </div>
          <br />
          <div>
            <label>Ping Retries</label>
            <input type="number" class="form-control" [formControl]="PingRetries" />
            @if (PingRetries.hasError('required')) {
              <div class="alert alert-danger">Ping Retries is required</div>
            }
            @if (PingRetries.hasError('minValue') || PingRetries.hasError('maxValue')) {
              <div class="alert alert-danger">Ping Retries must be in the range 0 - 10</div>
            }
          </div>
          <br />
          <div style="margin-top: 10px;">
            <input type="checkbox" [formControl]="AllowIPv6Crawl" />
            <span class="uv-checkbox-label">Allow IPv6 Crawl</span>
          </div>
        </fieldset>
      </div>
      <div class="col-lg-1">
      </div>
      <div class="col-lg-3">
        <fieldset>
          <legend>Advanced Settings</legend>
          <div style="margin-top: 10px;">
            <input type="checkbox" [formControl]="ResolveHostnames" />
            <span class="uv-checkbox-label">Resolve Hostnames</span>
          </div>
          <br />
          <div style="margin-top: 10px;">
            <input type="checkbox" [formControl]="ResolveNetBIOS" />
            <span class="uv-checkbox-label">Resolve NetBIOS</span>
          </div>
          <br />
          <div>
            <label for="devicemergesetting">Device Merge</label>
            <select name="devicemergesetting" class="form-control" style="padding: 3.75px;" [formControl]="DeviceMergeSetting">
              <option value="" [attr.selected]="(DeviceMergeSetting.value == '') ? '' : null">
                Default
              </option>
              <option value="Improved" [attr.selected]="(DeviceMergeSetting.value == 'Improved') ? '' : null">
                Improved
              </option>
              <option value="Aggressive" [attr.selected]="(DeviceMergeSetting.value == 'Aggressive') ? '' : null">
                Aggressive
              </option>
            </select>
          </div>
          <br />
          <div>
            <label>Max Threads</label>
            <input type="number" class="form-control" [formControl]="MaxThreads" />
            @if (MaxThreads.hasError('required')) {
              <div class="alert alert-danger">Max Threads is required</div>
            }
            @if (MaxThreads.hasError('minValue') || MaxThreads.hasError('maxValue')) {
              <div class="alert alert-danger">Max Threads must be in the range 1 - 250</div>
            }
          </div>
          <br />
          <div>
            <label>Max Device Time (minutes, 0 = no max)</label>
            <input type="number" class="form-control" [formControl]="MaxDeviceTime" />
            @if (MaxDeviceTime.hasError('required')) {
              <div class="alert alert-danger">Max Device Time is required</div>
            }
            @if (MaxDeviceTime.hasError('minValue') || MaxDeviceTime.hasError('maxValue')) {
              <div class="alert alert-danger">Max Device Time must be in the range 0 - 59</div>
            }
          </div>
          <br />
          <div>
            <label>SNMP Read Delay (milliseconds, 0 = no delay)</label>
            <input type="number" class="form-control" [formControl]="SnmpReadDelay" />
            @if (SnmpReadDelay.hasError('required')) {
              <div class="alert alert-danger">SNMP Read Delay is required</div>
            }
            @if (SnmpReadDelay.hasError('minValue') || SnmpReadDelay.hasError('maxValue')) {
              <div class="alert alert-danger">SNMP Read Delay must be in the range 0 - 15000</div>
            }
          </div>
        </fieldset>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-7">
        <fieldset>
          <legend>Device Config Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="CaptureConfigs" (change)="enableDisableControls()" />
        <span class="uv-checkbox-label">Capture Device Configurations</span>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="CaptureLogs" (change)="enableDisableControls()" />
        <span class="uv-checkbox-label">Capture Device Logs</span>
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 30px;">
      <div class="col-lg-2">
        <span>Captured Config Folder:</span>
      </div>
      <div class="col-lg-5">
        <input type="text" pInputText style="width: 100%;" [formControl]="ConfigExportFolder" />
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 30px; margin-bottom: 20px;">
      <div class="col-lg-2">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="CreateDateSubfolder" />
        <span class="uv-checkbox-label">Create Date Subfolder</span>
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="CreateDeviceSubfolder" />
        <span class="uv-checkbox-label">Create Device Subfolder</span>
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="SaveChangesOnly" />
        <span class="uv-checkbox-label">Save Changes Only</span>
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="ExportToServer" />
        <span class="uv-checkbox-label">Export Configs To Server</span>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-7">
        <fieldset>
          <legend>Port Scanning Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 30px;">
      <div class="col-lg-1">
        <span>TCP Ports:</span>
      </div>
      <div class="col-lg-5">
        <input type="text" pInputText style="width: 100%;" [formControl]="TcpPorts" />
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 5px;">
      <div class="col-lg-1">
        <span>UDP Ports:</span>
      </div>
      <div class="col-lg-5">
        <input type="text" pInputText style="width: 100%;" [formControl]="UdpPorts" />
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 5px;">
      <div class="col-lg-5">
        <input type="checkbox" [formControl]="KeepOpenPortsOnly" />
        <span class="uv-checkbox-label">Keep Open Ports Only</span>
      </div>
    </div>
  </form>
</div>
